import styled, { css } from 'styled-components';
import Sticky from './sticky';

export const CustomSticky = styled(Sticky)`
  background-color: white;
  border-top: 1px solid var(--grey300);
  bottom: 0;
  top: unset;
  height: 64px;
  display: flex;
  padding: 16px 24px;
  justify-content: center;
  align-items: flex-start;
  gap: 8px;
  ${(props) =>
    !!props.width &&
    css`
      width: ${props.width};
    `};
  ${(props) =>
    !!props.flexColumn &&
    css`
      flex-direction: column;
      height: unset;
      padding: 0;
      gap: 0;
    `};
`;
